import { defineStore } from 'pinia'
import { useQuery } from 'villus'
import { onMounted, ref } from 'vue'

import { EVENT_TAG } from '@/data/hardCode'
import { TagDocument } from '@/graphql/creator-platform/generated'
import { backendLocation } from '@/graphql/utils'

export const useEventStore = defineStore('event', () => {
  const isEventTagEnable = ref(false)
  const eventTagName = ref('')
  const eventTagEnName = ref('')
  onMounted(() => {
    void queryEventTagStatus()
  })
  async function queryEventTagStatus(): Promise<void> {
    const { data, error } = await useQuery({
      query: TagDocument,
      variables: { tagId: EVENT_TAG },
    })
    if (data.value !== null && error.value === null) {
      isEventTagEnable.value = true
      eventTagEnName.value = data.value.tagForDitto.name
      eventTagName.value =
        data.value.tagForDitto.tagI18ns.find((tag) => tag.location === backendLocation)?.name ??
        data.value.tagForDitto.name
    }
  }

  return {
    isEventTagEnable,
    eventTagName,
    eventTagEnName,
  }
})
